package org.catharsis.spendtel.core.auth

fun authErrorMessage(error: Throwable): String {
    val message = error.message.orEmpty()
    return when {
        message.contains("email-already-in-use", ignoreCase = true) ->
            "An account with this email already exists. Try signing in instead."
        message.contains("invalid-email", ignoreCase = true) ->
            "Please enter a valid email address."
        message.contains("weak-password", ignoreCase = true) ->
            "Password must be at least 6 characters."
        message.contains("operation-not-allowed", ignoreCase = true) ->
            "Email sign-up is not enabled yet. Please contact support."
        message.contains("unauthorized-domain", ignoreCase = true) ->
            "Sign-up isn't available on this domain yet. Please try again from spendtel.app."
        message.contains("network", ignoreCase = true) ->
            "There is a problem with your network connection."
        message.contains("credential is incorrect", ignoreCase = true) ||
            message.contains("wrong-password", ignoreCase = true) ||
            message.contains("user-not-found", ignoreCase = true) ||
            message.contains("invalid-credential", ignoreCase = true) ->
            "Incorrect email or password."
        message.contains("too-many-requests", ignoreCase = true) ->
            "Too many attempts. Please wait a moment and try again."
        message.contains("PERMISSION_DENIED", ignoreCase = true) ||
            message.contains("Missing or insufficient permissions", ignoreCase = true) ->
            "We couldn't save your profile yet. Try signing in."
        message.isNotBlank() -> message
        else -> "An error occurred, please try again"
    }
}
